/* Add-to-cart for the account pages. One file, loaded by the overview and the Orders page, so the
   two cannot drift apart.

   Handles two buttons:
     [data-add]        one variant id — the "Add to cart" on a buy-it-again card
     [data-add-order]  "variantId:qty,variantId:qty,…" in data-items — "Buy it again" on an order

   Both hand off to the theme's own cart drawer via dispatch:cart-drawer:refresh /
   dispatch:cart-drawer:open (see assets/cart-drawer.js), so adding from an account page behaves
   exactly like adding from a product card anywhere else. No bespoke confirmation UI. */
(function () {
  'use strict';

  function flash(btn, text, ms) {
    var label = btn.getAttribute('data-label') || btn.textContent;
    btn.setAttribute('data-label', label);
    btn.textContent = text;
    setTimeout(function () {
      btn.textContent = label;
      btn.disabled = false;
    }, ms);
  }

  /* Marks every line with the surface it came from, so "does buy-it-again actually get used?" is
     answerable from order data instead of guesswork. `_source` is underscore-prefixed, which hides
     it from the cart, checkout, emails and packing slips while persisting onto the order as a
     queryable lineItem.customAttribute. The button carries its own label via data-source so one
     script can serve the overview and the orders page without them being confused for each other. */
  function tag(items, source) {
    return items.map(function (i) {
      var props = {};
      for (var k in (i.properties || {})) props[k] = i.properties[k];
      props._source = source;
      var line = { id: i.id, quantity: i.quantity, properties: props };
      /* Shopify accepts `selling_plan` natively on /cart/add.js — that is why Appstle's own widget
         is replaceable at all, and why subscribing needs no Appstle write call. Only set the key
         when there IS a plan: sending selling_plan: null makes the add 422. */
      if (i.selling_plan) line.selling_plan = i.selling_plan;
      return line;
    });
  }

  function add(btn, items) {
    if (!items.length) {
      /* Every line is discontinued or sold out. Say so rather than firing an add that 422s. */
      btn.disabled = true;
      btn.textContent = 'No longer available';
      return;
    }

    var label = btn.textContent;
    btn.setAttribute('data-label', label);
    btn.disabled = true;
    btn.textContent = 'Adding…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: tag(items, btn.getAttribute('data-source') || 'account-buy-again') }),
    })
      .then(function (r) {
        if (r.ok) return r.json();
        /* 422 means it cannot be added — sold out, or the variant no longer exists. */
        return r.json().then(function (b) {
          throw new Error((b && b.description) || 'Could not add these items.');
        });
      })
      .then(function () {
        btn.textContent = 'Added';
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));
        flash(btn, 'Added', 2000);
      })
      .catch(function (err) {
        console.warn('[account] add to cart', err);
        flash(btn, 'Unavailable', 2500);
      });
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;

    var one = e.target.closest('[data-add]');
    if (one && !one.disabled) {
      e.preventDefault();
      /* Optional subscribe path: `data-plan-from` names the id of a <select> holding selling plan
         ids (the reorder card's frequency dropdown). Read AT CLICK TIME so no other script has to
         stamp the value on first — two document-level listeners would otherwise race, and losing
         that race would charge a ONE-TIME purchase to someone who believed they had subscribed.
         A missing or empty select just means a normal one-time add. */
      var planId = '';
      var planFrom = one.getAttribute('data-plan-from');
      if (planFrom) {
        var sel = document.getElementById(planFrom);
        if (sel) planId = sel.value || '';
      }
      add(one, [{
        id: Number(one.getAttribute('data-add')),
        quantity: 1,
        selling_plan: planId ? Number(planId) : null
      }]);
      return;
    }

    var whole = e.target.closest('[data-add-order]');
    if (whole && !whole.disabled) {
      e.preventDefault();
      /* Liquid already filtered data-items to lines whose exact variant is still available, so a
         partly discontinued order adds what it can rather than failing outright. */
      var items = (whole.getAttribute('data-items') || '')
        .split(',')
        .filter(Boolean)
        .map(function (pair) {
          var bits = pair.split(':');
          return { id: Number(bits[0]), quantity: Number(bits[1]) || 1 };
        })
        .filter(function (it) { return it.id; });
      add(whole, items);
    }
  });
})();
